import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PatientPaymentTransactionsUIHelpers";

const PatientPaymentTransactionssUIContext = createContext();

export function usePatientPaymentTransactionsUIContext() {
  return useContext(PatientPaymentTransactionssUIContext);
}

export const PatientPaymentTransactionsUIConsumer =
  PatientPaymentTransactionssUIContext.Consumer;

export function PatientPaymentTransactionsUIProvider({
  PatientPaymentTransactionsUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openDetailPatientPaymentTransactionPage:
      PatientPaymentTransactionsUIEvents.openDetailPatientPaymentTransactionPage,
  };

  return (
    <PatientPaymentTransactionssUIContext.Provider value={value}>
      {children}
    </PatientPaymentTransactionssUIContext.Provider>
  );
}
